import { render, staticRenderFns } from "./AdminBlock.vue?vue&type=template&id=792404c8"
import script from "./AdminBlock.vue?vue&type=script&lang=js"
export * from "./AdminBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports